import { jsx as _jsx } from "react/jsx-runtime";
import { createCustomBlockSpec } from '../../routines/createCustomBlockSpec.js';
import { useEditorContentOrSelectionChange } from '@blocknote/react';
import { Stack, Text } from '@mantine/core';
import { useState } from 'react';
const blockConfig = {
    content: 'none',
    propSchema: {},
    type: 'toc',
};
const getHeadings = (blocks) => {
    const headings = [];
    for (const block of blocks) {
        if (block.type === 'heading' && block.content?.length > 0) {
            const { content, props: { level }, } = block;
            const title = content
                .map((item) => {
                if (item.type === 'text') {
                    return item.text;
                }
                return item.content?.[0]?.text ?? '';
            })
                .join('');
            headings.push({
                id: block.id,
                level,
                title,
            });
        }
    }
    return headings;
};
const TableOfContentsElement = ({ headings }) => {
    if (headings.length === 0) {
        return (_jsx(Stack, { c: "#677084", py: 8, w: "100%", children: "Add headings to create a table of contents." }));
    }
    return (_jsx(Stack, { gap: 8, py: 8, w: "100%", children: headings.map(({ id, level, title }) => (_jsx("a", { href: "#", onClick: (event) => {
                event.preventDefault();
                event.stopPropagation();
                const element = document.querySelector(`[data-id="${id}"]`);
                if (element) {
                    window.scrollTo({
                        behavior: 'smooth',
                        top: element.getBoundingClientRect().top +
                            document.documentElement.scrollTop -
                            140,
                    });
                }
            }, children: _jsx(Text, { c: "#1650cf", id: id, pl: (level - 1) * 24, children: title }) }, id))) }));
};
const EditableTableOfContentsElement = ({ editor, }) => {
    const [headings, setHeadings] = useState(getHeadings(editor.document));
    useEditorContentOrSelectionChange(() => {
        setHeadings(getHeadings(editor.document));
    });
    return _jsx(TableOfContentsElement, { headings: headings });
};
export const TableOfContents = createCustomBlockSpec(blockConfig, {
    render: (props) => {
        if (props.readOnly) {
            return (
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _jsx(TableOfContentsElement, { headings: getHeadings(props.document) }));
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _jsx(EditableTableOfContentsElement, { editor: props.editor });
    },
    toExternalHTML: () => {
        return _jsx("hr", {});
    },
});
//# sourceMappingURL=TableOfContents.js.map